import { Alert, Button } from "reactstrap";
import { CyPlaylist } from "../CyPlaylist";
import { useTranslation } from "react-i18next";

interface Props {
  removeInvalidItems: () => void;
}

export function UnkownEntriesWarning({ removeInvalidItems }: Props) {
  const { t } = useTranslation();

  return (
    <Alert color="warning" data-cy={CyPlaylist.AlertUnknownSongs} fade={false}>
      <p>{t("playlist.edit.unknownEntriesTitle")}</p>
      <p>{t("playlist.edit.unknownEntriesMessage")}</p>
      <p>
        <Button onClick={() => removeInvalidItems()} color="warning">
          {t("playlist.edit.cleanUp")}
        </Button>
      </p>
    </Alert>
  );
}
